/**
 * Lightweight scroll reveal for [data-pi-reveal] (respects reduced motion).
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('[data-pi-reveal]').forEach((el) => el.classList.add('pi-reveal-in'));
    return;
  }

  const obs = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('pi-reveal-in');
        obs.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.12 },
  );

  function scan() {
    document.querySelectorAll('[data-pi-reveal]:not(.pi-reveal-in)').forEach((el) => obs.observe(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', scan);
})();
